//const imgDomain = process.env.NODE_ENV === 'production' ? 'http://cdn.biz.medsci.cn' : '/imgurl';
const imgDomain = process.env.NODE_ENV === 'production' ? 'https://img.medsci.cn' : '/imgurl';
export default {
    imgDomain
}